import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spinner, useToast } from '../components/ui';
import { api } from '../lib/api';
import type { Template } from '../lib/types';

export function TemplatesPage() {
  const toast = useToast();
  const navigate = useNavigate();
  const [templates, setTemplates] = useState<Template[] | null>(null);

  const load = () => api.listTemplates().then(setTemplates).catch((e) => toast.push(e.message, true));
  useEffect(() => { void load(); }, []);

  const duplicate = async (t: Template) => {
    const name = window.prompt('Name for the new template', `${t.name} (copy)`);
    if (!name) return;
    try {
      const copy = await api.duplicateTemplate(t.id, name);
      navigate(`/templates/${copy.id}`);
    } catch (e) {
      toast.push((e as Error).message, true);
    }
  };

  const remove = async (t: Template) => {
    if (!window.confirm(`Delete template "${t.name}"?`)) return;
    try {
      await api.deleteTemplate(t.id);
      toast.push('Template deleted');
      await load();
    } catch (e) {
      toast.push((e as Error).message, true);
    }
  };

  if (!templates) return <div className="row"><Spinner /> <span className="sub">Loading…</span></div>;

  return (
    <>
      <div style={{ marginBottom: 18 }}>
        <h1 className="title">Templates</h1>
        <div className="sub">
          Colours, fonts and page order of a booklet. The built-in WnW template is locked — duplicate it to make a variant.
        </div>
      </div>

      <div className="gallery">
        {templates.map((t) => (
          <div className="book-card" key={t.id}>
            <div className="thumb" onClick={() => navigate(`/templates/${t.id}`)} style={{ cursor: 'pointer' }}>
              <iframe className="thumb-frame" title={t.name} src={api.templatePreviewUrl(t.id)} tabIndex={-1} />
            </div>
            <div className="body">
              <div className="name">{t.name}</div>
              <div className="swatches">
                {[t.tokens.green, t.tokens.cream, t.tokens.lime].map((c) => <span key={c} style={{ background: c }} />)}
                <span className="sub" style={{ marginLeft: 6 }}>{t.tokens.display} / {t.tokens.body}</span>
              </div>
              <div className="sub">
                v{t.version} · used by {t.usedBy} booklet{t.usedBy === 1 ? '' : 's'}{t.builtIn ? ' · built-in' : ''}
              </div>
              <div className="row" style={{ gap: 6, marginTop: 10 }}>
                <button className="btn small" onClick={() => navigate(`/templates/${t.id}`)}>{t.builtIn ? 'View' : 'Edit'}</button>
                <button className="btn small" onClick={() => void duplicate(t)}>Duplicate</button>
                {!t.builtIn && <button className="btn small danger" onClick={() => void remove(t)}>Delete</button>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
